import { createContext, ReactNode, useContext, useMemo } from 'react';

import { platformConfigurationRegistry } from './platformConfiguration';
import { Configuration } from './model';
import { paymentMethodConfigurationProvider } from './paymentMethodConfiguration';

const ConfigurationContext = createContext<Configuration>({
  ...platformConfigurationRegistry.getDefault('v2'),
  ...paymentMethodConfigurationProvider.getDefault(),
});

//@TODO: implement attach submitInitiator dependencies
interface UIConfigurationProviderProps {
  platformName: string | null;
  version: 'v2' | 'v3' | 'v4';
  paymentMethodId: string | null;
  children: ReactNode;
}

export const UIConfigurationProvider = ({
  platformName,
  version,
  paymentMethodId,
  children,
}: UIConfigurationProviderProps) => {
  const configuration = useMemo(() => {
    const platformConfiguration = platformName
      ? platformConfigurationRegistry.get(platformName, version)
      : platformConfigurationRegistry.getDefault(version);

    const paymentMethodConfiguration = paymentMethodId
      ? paymentMethodConfigurationProvider.get(paymentMethodId)
      : paymentMethodConfigurationProvider.getDefault();

    return {
      ...platformConfiguration,
      ...paymentMethodConfiguration,
    };
  }, [platformName, version, paymentMethodId]);

  return (
    <ConfigurationContext.Provider value={configuration}>
      {children}
    </ConfigurationContext.Provider>
  );
};
export const useUIConfigurationContext = () => useContext(ConfigurationContext);
